// Build/version info baked into the bundle.
// VUE_APP_BUILD_ID is set by the CI workflow (short git sha + timestamp); 'dev' locally.
import pkg from '../../package.json'
const pkgVersion = pkg.version

export const APP_VERSION = process.env.VUE_APP_VERSION || pkgVersion
export const BUILD_ID = process.env.VUE_APP_BUILD_ID || 'dev'